import { Typography } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';

interface SubTitleProps extends PropsWithChildren<{ className?: string }> {
  className?: string;
  style?: React.CSSProperties;
}

const SubTitle: React.FC<SubTitleProps> = ({ className, children, style }: SubTitleProps) => (
  <Typography component="span" className={className} style={style} variant="h3">
    {children}
  </Typography>
);

export default SubTitle;
